/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetCharactersCharacterIdFleetNotFound
 */
export interface GetCharactersCharacterIdFleetNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetCharactersCharacterIdFleetNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdFleetNotFound interface.
 */
export function instanceOfGetCharactersCharacterIdFleetNotFound(value: object): value is GetCharactersCharacterIdFleetNotFound {
    return true;
}

export function GetCharactersCharacterIdFleetNotFoundFromJSON(json: any): GetCharactersCharacterIdFleetNotFound {
    return GetCharactersCharacterIdFleetNotFoundFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdFleetNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdFleetNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCharactersCharacterIdFleetNotFoundToJSON(json: any): GetCharactersCharacterIdFleetNotFound {
    return GetCharactersCharacterIdFleetNotFoundToJSONTyped(json, false);
}

export function GetCharactersCharacterIdFleetNotFoundToJSONTyped(value?: GetCharactersCharacterIdFleetNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

